import type { ValidateStatus } from 'antd/es/form/FormItem'

type ValidateStatusesMap = Record<string, ValidateStatus>

export const VALIDATE_STATUS: ValidateStatusesMap = {
  SUCCESS: 'success',
  WARNING: 'warning',
  VALIDATING: 'validating',
  ERROR: 'error',
  DEFAULT: ''
}
